import React, { useEffect, useState } from 'react'
import InputCustom from 'components/Inputs'
import CustomSelect from 'components/Select'
import useRedux from 'hooks/useRedux'
import * as campanhaActions from 'store/modules/backoffice/campanha/actions'
import { FiBriefcase } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { Col, Row } from 'reactstrap'
import { ApplicationState } from 'store'
import { CAMPANHA } from 'store/modules/backoffice/campanha/types'
import { SimpleTitleCard } from 'styles/global'
import { maskNumber, validarData } from 'util/masks'
import { toast } from 'react-toastify'

const Campanha = () => {
  const {
    register,
    optionsSelect,
    invalidsTabDadosGerais,
    visualizacao,
    tiposCampanha,
    activeTab
  } = useSelector<ApplicationState, CAMPANHA>((state) => state.campanha)

  const [selectKey, setSelectKey] = useState(() => Math.random())

  const { dispatch } = useRedux()

  type Fields = keyof CAMPANHA['register']
  function onChange<T extends Fields>(
    value: T extends Fields ? CAMPANHA['register'][T] : never,
    field: T
  ) {
    if (field === 'tipoCampanhaCrmId') {
      dispatch(campanhaActions.setRegisterFields([], 'empresasGrupo'))
    }
    dispatch(campanhaActions.setRegisterFields(value, field))
  }

  useEffect(() => {
    if (activeTab === 'register') {
      dispatch(campanhaActions.getTiposOperacaoSaga())
    }
  }, [dispatch, activeTab])

  useEffect(() => {
    const isCampanhaURA =
      register.tipoCampanhaCrmId === 'd38a3f12-927f-4936-8eee-6552ce2ed81e'

    if (!isCampanhaURA || !Array.isArray(register.empresasGrupo)) return

    const empresaComCodigo = register.empresasGrupo
      .map((sel) =>
        typeof sel === 'string'
          ? optionsSelect.empresasGrupos.find((x) => x.idGrupoELoja === sel)
          : sel
      )
      .find((item) => item?.codigoEmpresa)

    if (empresaComCodigo?.codigoEmpresa) {
      dispatch(campanhaActions.getPerguntasSaga(empresaComCodigo.codigoEmpresa))
    }
  }, [
    register.empresasGrupo,
    register.tipoCampanhaCrmId,
    optionsSelect.empresasGrupos,
    dispatch
  ])

  useEffect(() => {
    const isUraOuDiscador =
      register.tipoCampanhaCrmId === 'dfb8fbbe-d7b8-45d9-badf-7e1e18c943f9' || // DISCADOR
      register.tipoCampanhaCrmId === 'd38a3f12-927f-4936-8eee-6552ce2ed81e' // URA
    const empresaComCodigo = register.empresasGrupo
      .map((sel) =>
        typeof sel === 'string'
          ? optionsSelect.empresasGrupos.find((x) => x.idGrupoELoja === sel)
          : sel
      )
      .find((item) => item?.codigoEmpresa)

    if (empresaComCodigo?.codigoEmpresa && isUraOuDiscador) {
      dispatch(
        campanhaActions.getCategoriasDiscadorSaga(
          empresaComCodigo.codigoEmpresa
        )
      )
    }
  }, [
    dispatch,
    optionsSelect.empresasGrupos,
    register.empresasGrupo,
    register.tipoCampanhaCrmId
  ])

  useEffect(() => {
    if (register.tipoCampanhaCrmId) {
      dispatch(campanhaActions.getGruposLojasSaga())
    }
  }, [dispatch, register.tipoCampanhaCrmId])

  return (
    <div className="d-flex flex-column row-gap-10">
      <Row>
        <Col className="d-flex flex-column justify-content-end" md={6}>
          <label className="label-12">Tipos Campanha</label>
          <CustomSelect
            options={tiposCampanha}
            placeholder="Selecione"
            onChange={(e) => {
              onChange(e, 'tipoCampanhaCrmId')
            }}
            value={register.tipoCampanhaCrmId}
            disabled={visualizacao || !!register.id}
            accessorLabel="descricao"
            accessorValue="id"
          />
        </Col>
      </Row>
      <hr />
      <SimpleTitleCard>
        <FiBriefcase className="icon" />
        Campanha
      </SimpleTitleCard>
      <Row>
        <Col className="d-flex flex-column justify-content-end" md={6}>
          <label className="label-12">Descrição*</label>
          <InputCustom
            type="text"
            placeholder="Digite aqui"
            onChange={(e) => {
              onChange(e.target.value, 'descricao')
            }}
            value={register.descricao}
            invalid={invalidsTabDadosGerais.descricao}
            disabled={visualizacao}
          />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex flex-column justify-content-start" md={6}>
          <label className="label-12">Tipo de operação</label>
          <CustomSelect
            options={optionsSelect.tiposOperacao}
            placeholder="Selecione"
            onChange={(e) => {
              onChange(e, 'tipoOperacaoId')
            }}
            value={register.tipoOperacaoId}
            accessorLabel="descricao"
            accessorValue="id"
            invalid={invalidsTabDadosGerais.tipoOperacaoId}
            disabled={visualizacao}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-end">
          <CustomSelect
            key={selectKey}
            options={optionsSelect.empresasGrupos}
            isMulti
            placeholder="Selecione empresas/grupos"
            onChange={(e) => {
              const selecionadosIds = Array.isArray(e) ? e : e ? [e] : []

              const selecionadosCompletos = optionsSelect.empresasGrupos.filter(
                (opt) => selecionadosIds.some((sel) => sel === opt.idGrupoELoja)
              )

              const lojasSemCodigo = selecionadosCompletos.filter(
                (item) =>
                  (!item.codigoEmpresa || item.codigoEmpresa.trim() === '') &&
                  item.descricao.startsWith('Loja -')
              )

              const isUraOuDiscador =
                register.tipoCampanhaCrmId ===
                'dfb8fbbe-d7b8-45d9-badf-7e1e18c943f9'
              register.tipoCampanhaCrmId ===
                'd38a3f12-927f-4936-8eee-6552ce2ed81e'

              if (isUraOuDiscador) {
                let erro = false
                if (lojasSemCodigo.length > 0) {
                  erro = true
                  const nomes = lojasSemCodigo
                    .map((item) => item.descricao)
                    .join(', ')
                  toast.error(
                    `É necessário cadastrar o código de empresa para esta loja: ${nomes}`,
                    { autoClose: false }
                  )
                }
                selecionadosCompletos.forEach((selecionado) => {
                  if (selecionado.erros?.length > 0) {
                    erro = true
                    selecionado.erros.forEach((erro) => {
                      toast.warn(erro.erro, { autoClose: false })
                    })
                  }
                })
                if (erro) {
                  setSelectKey(Math.random())
                  return
                }
              }

              onChange(selecionadosIds, 'empresasGrupo')
            }}
            value={register.empresasGrupo}
            accessorLabel="descricao"
            accessorValue="idGrupoELoja"
            invalid={invalidsTabDadosGerais.empresasGrupo}
            disabled={visualizacao || !!register.id}
          />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex flex-column justify-content-end" md={3}>
          <label className="label-12">Data início campanha*</label>
          <InputCustom
            type="date"
            onInput={validarData}
            onChange={(e) => onChange(e.target.value, 'dataInicioCampanha')}
            value={register.dataInicioCampanha}
            invalid={invalidsTabDadosGerais.dataInicioCampanha}
            disabled={visualizacao}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-end" md={3}>
          <label className="label-12">Data final campanha*</label>
          <InputCustom
            type="date"
            onInput={validarData}
            onChange={(e) => {
              onChange(e.target.value, 'dataFimCampanha')
            }}
            value={register.dataFimCampanha}
            invalid={invalidsTabDadosGerais.dataFimCampanha}
            disabled={visualizacao}
          />
        </Col>
      </Row>
      <Row>
        <Col className="d-flex flex-column justify-content-end" md={6}>
          <label className="label-12">Quantidade de clientes*</label>
          <InputCustom
            type="text"
            placeholder="Digite aqui"
            onChange={(e) => {
              onChange(Number(maskNumber(e.target.value)), 'quantidadeClientes')
            }}
            value={register.quantidadeClientes}
            invalid={invalidsTabDadosGerais.quantidadeClientes}
            disabled={visualizacao}
          />
        </Col>
      </Row>
    </div>
  )
}
export default Campanha
